import React from "react";
import styled from "styled-components";
import "@fontsource/ibm-plex-mono";

const DeliveryContainer = styled.div`
  position: relative;
  background-color: white;
  padding-left: min(4%, 40px);
  padding-right: min(4%, 40px);
  padding-bottom: 3%;
`;

const Title = styled.h2`
  color: #000000;
  font-family: "IBM Plex Mono", Helvetica, monospace;
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 20px;
  margin-top: 20px;
  text-align: center;
`;

const SectionTitle = styled.h3`
  color: #000000;
  font-family: "IBM Plex Mono", Helvetica, monospace;
  font-size: 18px;
  font-weight: 600;
  margin: 15px 0 10px 0;
`;

const Text = styled.p`
  color: #000000;
  font-family: "IBM Plex Mono", Helvetica, monospace;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  margin: 8px 0;
  text-indent: 2.5em;
  text-align: justify;
`;

const ListItem = styled.li`
  color: #000000;
  font-family: "IBM Plex Mono", Helvetica, monospace;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  margin: 8px 0;
  text-align: justify;  
`;

const UnorderedList = styled.ul`
  padding-left: 20px;
  @media(min-width: 1024px) {
    padding-left: 40px;
  }
`;

const OrderedList = styled.ol`
  padding-left: 20px;
  @media(min-width: 1024px) {
    padding-left: 40px;
  }
`;

const DeliveryConditions: React.FC = () => {
  return (
    <DeliveryContainer>
      <Title>Умови доставки</Title>
      
      <Text>
        Служба доставки працює без свят і вихідних. 
        Жителі Києва можуть отримати замовлення вже в день його оформлення! 
        Клієнти з інших міст України можуть отримати замовлення 
        протягом 1-5 днів залежно від місцезнаходження Вашого населеного пункту та обраного способу доставки 
        (кур'єрська доставка особисто в руки в зазначений населений пункт, доставка до представництв "Нової Пошти"). 
        Доступні способи доставок, їхню точну вартість і точні терміни 
        Ви можете побачити під час оформлення замовлення в кошику замовлення, 
        після вибору Вашого міста доставки.
      </Text>

      <SectionTitle>Кур'єрська доставка (особисто в руки)</SectionTitle>
      
      <Text>
        Жителі Києва можуть отримати вподобані товари вже в день замовлення! 
        Кур'єр доставить Вам у вказаний час і місце замовлені товари.
      </Text>

      <Text>
        Доставка здійснюється щодня з 10:00 до 21:00. Ми працюємо без свят і
        вихідних!
      </Text>

      <Text>Для зручності клієнтів весь період доставки розбито на три часові інтервали:</Text>
      <UnorderedList>
        <ListItem>10:00-13:00</ListItem>
        <ListItem>14:00-17:00</ListItem>
        <ListItem>19:00-21:00</ListItem>
      </UnorderedList>

      <Text>
        Під час оформлення замовлення необхідно обрати день та інтервал доставки. 
        Важливо пам'ятати, що Ви можете оформити замовлення на певний інтервал не пізніше ніж за 1 годину до його початку. 
        Наприклад, якщо Ви хочете, щоб замовлення було доставлено в інтервал 14:00-17:00, 
        необхідно оформити замовлення до 13:00 цього дня.
      </Text>

      <UnorderedList>
        <ListItem>Замовлення може бути доставлене на будь-яку адресу (домашню, робочу або будь-яку іншу, зручну для Вас)</ListItem>
        <ListItem>
          Замовлення можна оплатити готівкою (у момент отримання замовлення), банківським платежем 
          (замовлення Вам буде відправлено після фактичного надходження грошей на рахунок) 
          або платіжною карткою (під час оформлення замовлення).
        </ListItem>
        <ListItem>До замовлення додається товарний чек</ListItem>
      </UnorderedList>

      <SectionTitle>Доставка і вартість по Україні та Київській області</SectionTitle>
      
      <OrderedList>
        <ListItem>Доставка кур'єром особисто в руки:</ListItem>
        <UnorderedList>
          <ListItem>
            Вартість доставки:
            <Text>Вартість доставки кур'єром до дверей (особисто в руки) становить 200 грн.</Text>
          </ListItem>
          <ListItem>
            Терміни доставки:
            <OrderedList>
              <ListItem>
                Доставка протягом доби здійснюється в міста: Біла Церква, Бровари, 
                Вінниця, Дніпродзержинськ, Дніпропетровськ, Житомир, Запоріжжя, 
                Івано-Франківськ, Кіровоград, Кременчук, Кривий Ріг, Луцьк, Лубни, Львів, 
                Мукачеве, Миколаїв, Одеса, Павлоград, Полтава, Рівне, Суми, Тернопіль, Ужгород, 
                Харків, Херсон, Хмельницький, Черкаси, Чернігів, Чернівці.
              </ListItem>
              <ListItem>
                Доставка протягом 2-4 днів здійснюється в міста: Іллічівськ. Доставка в інші міста 
                України здійснюється згідно з графіком. Більш детальну інформацію щодо термінів доставки у 
                Ваш населений пункт Ви можете отримати під час оформлення доставки на нашому сайті.
              </ListItem>
            </OrderedList>
          </ListItem>
        </UnorderedList>
        <ListItem>
          Доставка за кордон
        </ListItem>
        <Text>
          Доставка в зарубіжні країни буде виконана авіапоштою за вказаною Вами адресою за кордоном. 
          Термін цього виду доставки може становити 3-5 робочих тижнів.
        </Text>
        <UnorderedList>
          <ListItem>Оплата замовлення:</ListItem>
          <OrderedList>
            <ListItem>
              Замовлення можна оплатити післяплатою (у момент отримання замовлення), банківським платежем 
              (замовлення Вам буде відправлено після фактичного надходження грошей на рахунок) або платіжною 
              карткою (під час оформлення замовлення).
            </ListItem>
            <ListItem>
              Наш інтернет-магазин приймає до оплати будь-які пластикові платіжні картки, емітовані українськими банками.
            </ListItem>
            <ListItem>
              Під час оплати пластиковими платіжними картками, емітованими банками країн СНД, ці картки мають підтримувати 
              технологію двофакторної аутентифікації користувача 3-D Secure або більш ранню 2-D Secure.
            </ListItem>
            <ListItem>
              Під час оплати пластиковими платіжними картками, емітованими банками зарубіжних країн (окрім СНД), 
              ці картки мають підтримувати технологію двофакторної автентифікації користувача 3-D Secure.
            </ListItem>
            <ListItem>
              У процесі проведення оплати пластиковою платіжною карткою, Ваш банк може запросити Вас пройти додаткову верифікацію 
              за допомогою введення оригінального цифрового коду, який буде надіслано Вам на Ваш мобільний телефон (ми не впливаємо 
              на процес цієї верифікації/перевірки).
            </ListItem>
          </OrderedList>
        </UnorderedList>
        <ListItem>Доставка на склад "Нової Пошти" (замовлення забирається в пункті самовивозу)</ListItem>
        <Text>
          Експрес доставка здійснюється в понад 582 представництва, в більш ніж 324 містах України. 
          Замовлення буде доставлено в пункт самовивозу протягом 1 дня. Повний перелік відділень, адреси та телефони 
          Ви можете дізнатися, відвідавши сайт "Нова Пошта".
        </Text>
        <UnorderedList>
          <ListItem>Вартість доставки:</ListItem>
          <OrderedList>
            <ListItem>Вартість доставки замовлення в пункт самовивозу Вашого міста становить 60-120 грн.</ListItem>
          </OrderedList>
          <ListItem>Зверніть увагу:</ListItem>
          <OrderedList>
            <ListItem>Замовлення, оформлені до 16-00, доставляються в пункт самовивозу протягом 1 дня.</ListItem>
            <ListItem>
              Замовлення може безкоштовно зберігатися на складі "Нової Пошти" 5 робочих днів, 
              включно з днем, коли його має забрати одержувач.
            </ListItem>
          </OrderedList>
          <ListItem>Оплата замовлення:</ListItem>
          <OrderedList>
            <ListItem>
              Замовлення можна оплатити післяплатою (в момент отримання замовлення - додатково 
              Ви оплатите комісію в розмірі 37 грн. за пересилання нам грошей), банківським платежем 
              (замовлення Вам буде відправлено після фактичного надходження грошей на рахунок) або платіжною карткою 
              (під час оформлення замовлення).
            </ListItem>
            <ListItem>
              Наш інтернет-магазин приймає до оплати будь-які пластикові платіжні картки, емітовані українськими банками.
            </ListItem>
            <ListItem>
              Під час оплати пластиковими платіжними картками, емітованими банками країн СНД, ці картки мають підтримувати 
              технологію двофакторної аутентифікації користувача 3-D Secure або більш ранню 2-D Secure.
            </ListItem>
            <ListItem>
              Під час оплати пластиковими платіжними картками, емітованими банками зарубіжних країн (окрім СНД), 
              ці картки мають підтримувати технологію двофакторної автентифікації користувача 3-D Secure.
            </ListItem>
            <ListItem>
              У процесі проведення оплати пластиковою платіжною карткою, Ваш банк може запросити Вас пройти додаткову верифікацію за 
              допомогою введення оригінального цифрового коду, який буде надіслано Вам на Ваш мобільний телефон (ми не впливаємо на процес цієї 
              верифікації/перевірки).
            </ListItem>
          </OrderedList>
        </UnorderedList>
        <ListItem>
          Повернення замовлення:
          <Text>
            Відповідно до чинного закону України про Захист прав споживачів та Постанови Кабінету Міністрів України №172 від 19.03.1994 р. 
            (Додаток 3 - Перелік товарів) друковані видання входять до переліку непродовольчих товарів належної якості, 
            які не підлягають поверненню або обміну. 
            </Text>
        </ListItem>
      </OrderedList>
    </DeliveryContainer>
  );
};

export default DeliveryConditions;